


























































import axios from "axios";
import Vue from "vue";
import { PaginatedResult, Room, ShortURL } from "../../interfaces";
import { deleteURL } from "../../services";
import UrlForm from './URLForm.vue';

export default Vue.extend({
  components: {
    UrlForm
  },
  data: () => ({
    urls: [] as ShortURL[],
    totalCount: 0,
    loading: true,
    searchText: '',
    headers: [
      {
        text: "Code",
        value: "code",
        sortable: false
      },
      { text: "Ziel", value: "target", sortable: false },
      { text: "Clicks", value: "clicks", sortable: false, filterable: false },
      { text: "User", value: "user", sortable: false },
      { text: "Aktionen", value: "actions", sortable: false, filterable: false },
    ],
    selectedItem: {} as Room,
    showDeleteDialog: false,
    showEditDialog: false,
    options: { page: 1, itemsPerPage: 10 },

  }),
  watch: {
    options: {
        async handler () {
          // await this.fetchData()
        },
        deep: true,
      },
  }, 
  async created() {
    await this.fetchData();
  },
  methods: {
    closeDelete() {
      this.selectedItem = {} as Room;
      this.showDeleteDialog = false;
    },
    deleteItem(item) {
      this.selectedItem = Object.assign({}, item);
      this.showDeleteDialog = true;
    },
    async deleteItemConfirm() {
      await deleteURL(this.selectedItem.id);
      this.selectedItem = {} as Room;
      await this.fetchData();
      this.showDeleteDialog = false;
    },
    async closeEditDialog(update: boolean) {
      if (update) {
        await this.fetchData();
      }
      this.showEditDialog = false;
      this.selectedItem = {} as Room;
    },
    editItem(room?: Room) {
      if (room) {
        this.selectedItem = Object.assign({}, room);
      } else {
        this.selectedItem = {} as Room;
      }
      this.showEditDialog = true;
    },

    async fetchData() {
      const { page, itemsPerPage } = this.options
      this.loading = true;
      const params: Record<string, number | string> = {};
      params.page = page;
      params['page_size'] = 10000;
      const res = await axios.get<PaginatedResult<ShortURL>>(`/api/urls/`, {
        params,
      });
      this.urls = res.data.results.map(e => ({...e, canEdit: false}));
      this.totalCount = res.data.count;
      this.loading = false;
    },
  },
});
